// removed by extract-text-webpack-plugin
module.exports = {"dragArea":"_33X37vXRPzWNr_2-"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectView/Viewport/DragArea.pcss
// module id = 505
// module chunks = 1